export default "__VITE_ASSET__mGp184Fm__"